import { z } from 'zod';

export const AppRole = z.enum(['Requester', 'FinanceApprover', 'D365Admin', 'AppAdmin']);
export type AppRole = z.infer<typeof AppRole>;

export const RequestStatus = z.enum([
  'Draft',
  'Submitted',
  'InReview',
  'Approved',
  'Provisioning',
  'NeedsAttention',
  'Validating',
  'Ready',
  'Cancelled',
]);
export type RequestStatus = z.infer<typeof RequestStatus>;

export const DocumentType = z.enum(['PurchaseRequisition', 'PurchaseOrder', 'VendorInvoice', 'Journal']);
export type DocumentType = z.infer<typeof DocumentType>;

export const PeopleSheet = z.enum([
  'users',
  'workers',
  'positions',
  'assignments',
  'approvalLimits',
  'roles',
  // Master data tabs: created in the new company over OData (importCustomersVendors, importProjects).
  'customers',
  'vendors',
  'projectContracts',
  'projects',
]);
export type PeopleSheet = z.infer<typeof PeopleSheet>;

export const PeopleImportStatus = z.enum(['Draft', 'Invalid', 'Valid', 'Applying', 'Applied', 'Failed']);
export type PeopleImportStatus = z.infer<typeof PeopleImportStatus>;

export const PeopleImportSource = z.enum(['File', 'Grid', 'CopiedFromVenue']);
export type PeopleImportSource = z.infer<typeof PeopleImportSource>;

/** Provisioning steps in execution order (spec section 11.1). */
export const StepKey = z.enum([
  'preflight',
  'createLegalEntity',
  'addressAndRegistration',
  'copyFromTemplate',
  'venueOverrides',
  'importPeople',
  'assignSecurity',
  'importCustomersVendors',
  'importProjects',
  'policiesAndParameters',
  'importWorkflows',
  'validate',
  'notify',
]);
export type StepKey = z.infer<typeof StepKey>;

export const StepStatus = z.enum(['Pending', 'Running', 'Skipped', 'Succeeded', 'Failed']);
export type StepStatus = z.infer<typeof StepStatus>;

export const RunKind = z.enum(['ProvisionVenue', 'ApplyPeopleImport']);
export type RunKind = z.infer<typeof RunKind>;

export const RunStatus = z.enum(['Running', 'NeedsAttention', 'Succeeded', 'Cancelled']);
export type RunStatus = z.infer<typeof RunStatus>;

/** Data management GetExecutionSummaryStatus values (spec section 11.5). */
export const DmfStatus = z.enum([
  'Unknown',
  'NotRun',
  'Executing',
  'Succeeded',
  'PartiallySucceeded',
  'Failed',
  'Canceled',
]);
export type DmfStatus = z.infer<typeof DmfStatus>;

export const DMF_TERMINAL_STATUSES: readonly DmfStatus[] = [
  'Succeeded',
  'PartiallySucceeded',
  'Failed',
  'Canceled',
];
